<template>
    <div class="seriesView">
        <v-container fluid>
            <v-row>
                <v-col cols="12" md="6" sm="6" class="text-left groupSelectSeries">
                    <v-autocomplete
                        v-model="selectedPracticeModel"
                        :items="filteredPractices"
                        item-value="id"
                        item-text="name"
                        return-object

                        outlined
                        dense
                        :no-data-text="$t('common.no_data')"
                    ></v-autocomplete>
                </v-col>


                <v-col cols="12" md="6" sm="12" class="text-left groupBtns">
                    <CreatePracticeDialog ref="createPracticeDialog" @createPractice="createPractice" @deletePractice="deletePractice"/>
                </v-col>

                <v-card class="mx-auto" width="100%" outlined v-if="selectedPracticeModel">
                    <v-app-bar color="accent" dense elevation="0">
                        <v-toolbar color="accent" dense elevation="0" class="forceHeightSmall">{{
                            $t('page.practice.selected_practice') }}: {{ practiceName }}</v-toolbar>
                    </v-app-bar>

                    <v-card class="tabscard">
                        <v-expansion-panels v-model="panel" multiple>
                            <v-expansion-panel>
                                <v-expansion-panel-header color="secondary" class="text-customizer-accent">
                                    {{ this.$t("page.practice.practice_details") }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <br />
                                    <PracticeDetails ref="practiceDetails" :practiceDetails="practiceDetails" @updatePractice="updatePractice"/>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            
                            <v-expansion-panel>
                                <v-expansion-panel-header color="secondary" class="text-customizer-accent">
                                    {{ this.$t("page.practice.practice_pricing") }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <br />
                                    <PracticePrice
                                    ref="practicePrice"
                                    :practicePrices="practicePrices"
                                    @createPracticePrice="createPracticePrice"
                                    @updatePracticePrice="updatePracticePrice"
                                    @deletePracticePrice="deletePracticePrice" />
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header color="secondary" class="text-customizer-accent">
                                    {{ this.$t("page.practice.practice_registrant") }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <br />
                                    <PracticeRegistrant
                                    ref="practiceregistrant"
                                    :practiceRegistrants="practiceRegistrants" />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                </v-card>
            </v-row>
        </v-container>

        <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotification = false;" @agree="destroySerie()" type="warning" :acept="$t('common.form.delete')"
            :reject="$t('common.form.cancel')" />
        <v-snackbar v-model="snackbar" timeout="3000" :color="color_snackbar">
            {{ msg_snackbar }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
    
<script>
import EventPracticeService from "@/components/services/EventPracticeService";
import EventPracticePriceService from "@/components/services/EventPracticePriceService";
import EventPracticeRegistrantService from "@/components/services/EventPracticeRegistrantService";
import CreatePracticeDialog from "@/components/practice/CreatePracticeDialog.vue";
import PracticeDetails from "@/components/practice/PracticeDetails.vue";
import PracticePrice from "@/components/practice/PracticePrice.vue";
import PracticeRegistrant from "@/components/practice/PracticeRegistrant.vue";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

export default {
    components: {
        CreatePracticeDialog,
        PracticeDetails,
        PracticePrice,
        PracticeRegistrant,
        SGSNotificationConfirm
    },
    data() {
        return {
            dialogNotification: false,
            panel: [],
            dateFrom: null,
            dateTo: null,
            snackbar: false,
            color_snackbar: '',
            msg_snackbar: '',
            practices: [],
            selectedPracticeModel: null,
            practiceDetails: null,
            practicePrices: null,
            practiceRegistrants: null
        };
    },
    computed: {
        eventId() {
            return this.$route.params.id;
        },

        lang() {
            let response;

            switch (this.$i18n.locale) {
                case "en":
                    response = 1;
                    break;
                case "fr":
                    response = 2;
                    break;
                case "es":
                    response = 3;
                    break;
                default:
                    response = 1;
            }

            return response;
        },

        filteredPractices() {
            let practices = [];

            this.practices.forEach(p => {
                let added = false;
                p.translations.forEach(l => {
                    if (l.fkLanguageCode == this.lang) {
                        practices.push({
                            id: p.id,
                            name: l.practiceName
                        });
                        added = true;
                    }
                })

                /**
                 * If not found in current language, add the practice name in english
                 */
                if(!added) {
                    const translation = p.translations.find(l => l.practiceName.length > 0);
                    practices.push({
                        id: p.id,
                        name: translation.practiceName
                    })
                }
            })

            return practices;
        },

        practiceName() {
            return this.selectedPracticeModel.name;
        },
    },
    watch: {
        filteredPractices(val) {
            if(!val) {
                this.selectedPracticeModel = null;
                return;
            }

            if(!this.selectedPracticeModel)this.selectedPracticeModel = val[0];
        },

        selectedPracticeModel(val) {

            if(!val){
                this.panel = [];
                return
            }

            this.panel = [0]
            
            const practice = {
                id: null,
                en: {
                    id: '',
                    name: ''
                },
                fr: {
                    id: '',
                    name: ''
                },
                es: {
                    id: '',
                    name: ''
                }
            }

            const matchingPractice = this.practices.find(p => p.id == val.id);
            practice.id = matchingPractice.id;

            matchingPractice.translations.forEach(l => {
                switch (l.fkLanguageCode) {
                    case 1:
                        practice.en.id = l.id;
                        practice.en.name = l.practiceName;
                        break;
                    case 2:
                        practice.fr.id = l.id;
                        practice.fr.name = l.practiceName;
                        break;
                    case 3:
                        practice.es.id = l.id;
                        practice.es.name = l.practiceName;
                        break;
                }
            });

            this.practiceDetails = practice;

            this.getPracticesPrices();

            this.getPracticeRegistrants();
        }
    },
    mounted() {
        const d = new Date();
        const curYear = d.getFullYear();
        
        this.dateFrom = `${curYear}-01-01`;
        this.dateTo = `${curYear}-12-31`;
        
        this.getPractices();
    },
    methods: 
    {
        setPracticeDetails() {
            this.$nextTick(() => {
                this.$refs.practiceDetails.setPracticeDetails(this.practiceDetails);
            })
        },
        async createPractice(fields)
        {

            let languages = [];

            if (fields.english != '') {
                languages.push({
                    languageCode: 1,
                    name: fields.english
                });
            }

            if (fields.french != '') {
                languages.push({
                    languageCode: 2,
                    name: fields.french
                });
            }

            if (fields.spanish != '') {
                languages.push({
                    languageCode: 3,
                    name: fields.spanish
                });
            }

            let practice = {
                eventId: this.eventId,
                languages: languages
            };

            EventPracticeService.create(practice).then(response => {
                if (response.data.success == 1) {
                    this.$refs.createPracticeDialog.close();
                    this.getPractices();
                }
            });
        },
        async updatePractice(practice) {
            const data = {};
            data.id = practice.id;
            data.eventId = this.eventId;
            data.languages = {};

            data.languages.en = {
                id: practice.en.id,
                name: practice.en.name
            };
            data.languages.fr = {
                id: practice.fr.id,
                name: practice.fr.name
            };

            data.languages.es = {
                id: practice.es.id,
                name: practice.es.name
            };

            EventPracticeService.update(data).then(response => {
                this.$refs.practiceDetails.setLoadig(false);
                if (response.data.success == 1) {
                    this.getPractices();
                }
            });
        },
        async deletePractice() {
            EventPracticeService.delete(this.eventId, this.selectedPracticeModel.id).then(response => {
                if (response.data.success == 1) {
                    this.selectedPracticeModel = null;
                    this.getPractices();
                }
            });
        },
        async getPractices() {
            EventPracticeService.getAll(this.eventId).then(response => {
                if (response.data.success == 1) {
                    this.practices = response.data.message;
                }
            });
        },
        async getPracticesPrices() {
            EventPracticePriceService.getAll(this.eventId, this.selectedPracticeModel.id).then(response => {
                if (response.data.success == 1) {
                    this.practicePrices = response.data.message;
                }
            });
        },
        async createPracticePrice(practicePrice) {
            practicePrice.fkEventsId = this.eventId;
            practicePrice.fkEventPracticeId = this.selectedPracticeModel.id;
            EventPracticePriceService.create(practicePrice).then(response => {
                if (response.data.success == 1) {
                    this.getPracticesPrices();
                }
            });
        },
        async updatePracticePrice(practicePrice) {
            practicePrice.fkEventsId = this.eventId;
            practicePrice.fkEventPracticeId = this.selectedPracticeModel.id;
            EventPracticePriceService.update(practicePrice).then(response => {
                if (response.data.success == 1) {
                    this.getPracticesPrices();
                }
            });
        },
        async deletePracticePrice(priceId) {
            EventPracticePriceService.delete(this.eventId, this.selectedPracticeModel.id, priceId).then(response => {
                if (response.data.success == 1) {
                    this.getPracticesPrices();
                }
            });
        },
        async getPracticeRegistrants() {
            EventPracticeRegistrantService.getAll(this.eventId, this.selectedPracticeModel.id).then(response => {
                if (response.data.success == 1) {
                    this.practiceRegistrants = response.data.message;
                }
            });
        },
    }
}
</script>
    
<style scoped>
.orlbl {
    font-weight: bold;
    font-size: 14px;
    margin-right: 20px;
}

.newseriesbtn {
    margin-top: 0px !important;
}

.srs_fset {
    padding: 0.35em 0.625em 0.75em !important;
    margin: 5px !important;
    border: 1px solid var(--lighten-base) !important;
}

.srs_lgd {
    width: auto !important;
    font-size: 15px !important;
    border-bottom: none !important;
    margin-bottom: 0px !important;
}

.customlink {
    color: var(--v-primary-base);
    font-weight: bold;
    text-decoration: underline;
}

.tabscard {
    margin: 10px 5px;
}

.v-tab {
    text-transform: initial;
}
</style>
    
<style scss>
.dNot700 {
    display: none;
}

.forceHeightSmall {
    margin-left: .5rem;
}

.groupBtns .v-btn {
    margin-top: 0px !important;
}

@media (max-width: 959px) {
    .groupBtns {
        padding-top: 0px;
    }
}

@media (max-width: 700px) {
    .d700 {
        display: none;
    }

    .dNot700 {
        display: block;
    }

    .forceHeightSmall>div {
        min-height: 48px;
        height: auto !important;
    }

    .groupBtns .v-btn {
        margin-top: .5rem !important;
    }

    .groupSelectSeries,
    .groupSelectOthers {
        padding: 12px 12px calc(12px - .5rem);
    }

    .v-expansion-panel-content__wrap {
        padding-left: 0px;
        padding-right: 0px;
    }

    .seriesView .v-card__text {
        padding: 5px;
    }
}

@media (min-width: 1024px) {
    .breadcrumb-c {
        display: none !important;
    }
}

.v-dialog>.v-card>.v-card__actions {
    padding: 20px 16px;
}

.borderDialog {
    border: 1px solid;
    border-color: black !important;
}

@media (min-width: 712px) {
    .deleteSeries {
        float: right !important;
    }
}</style>
    